import React, { useEffect, useState } from "react";
import classes from "./uploadModal.module.scss";

import { UploadImage } from "scenes/DecisionMatrix";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from "./close.svg";
import { UpdateOption } from "redux/DecisionMatrix/UpdateOptions/action";
import { AppLoading } from "components/AppLoading";
import { Spin } from "antd";

const UploadModal = ({ option, setIsUpload, decisionId, setOption }) => {
  // let {name} = option;
  const [imageX, setImage] = useState({
    image: "",
    size: "",
    type: "image/jpeg",
  });

  const [imgForAdding, setImgForAdding] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isClose, setIsClose] = useState(false);
  const dispatch = useDispatch();

  const { success: userOption, loading: userOptionLoading } = useSelector(
    (state) => state.getOptionReducer
  );

  const { loading: imgLoader, success } = useSelector(
    (state) => state.updateOptionsReducer
  );

  const { success: decision, loading: decisionLoading } = useSelector(
    (state) => state.getDecisionDetailsReducer
  );

  let { image, size, type } = imageX;

  const isJpgOrPng =
    type === "image/jpeg" || type === "image/png" || type === "image/webp";

  return (
    <div className={classes.bg}>
      <div className={classes.wrapper}>
        <div className={classes.header}>
          <span>Upload Picture</span>
          <button
            type="button"
            onClick={() => {
              setIsUpload(false);
            }}
            className={classes.close}
            title="Close"
          >
            <CloseIcon />
          </button>
        </div>
        <div className={classes.body}>
          <span className={classes.warning}>
            {size >= 2 && (
              <span className={classes.centred}>
                <div>Image must smaller than 2MB!</div>
                <div>Select another image!</div>
              </span>
            )}
            {!isJpgOrPng && (
              <span>
                <div>You can only upload JPG/PNG/WEBP file!</div>
              </span>
            )}
          </span>
          {option.image ? (
            <img src={option.image} alt="" />
          ) : (
            <UploadImage
              setImgForAdding={setImgForAdding}
              imgForAdding={imgForAdding}
              setImage={setImage}
              loading={loading}
              setLoading={setLoading}
              option={option}
            />
          )}
        </div>
        <div className={classes.footer}>
          {imgForAdding || option.image ? (
            <button
              className={classes.delete}
              onClick={() => {
                if (option.image) {
                  dispatch(
                    UpdateOption(
                      {
                        id: option.id,
                        body: { image: null },
                      },
                      decisionId
                    )
                  );
                }
                setImage({ ...imageX, image: null });
                setLoading(true);
                setTimeout(() => {
                  setLoading(false);
                }, 500);
                setImgForAdding(null);
              }}
            >
              DELETE
            </button>
          ) : (
            ""
          )}
          {image && imgForAdding && size < 2 && isJpgOrPng && (
            <button
              className={classes.upload}
              disabled={loading}
              onClick={() => {
                dispatch(
                  UpdateOption({ id: option.id, body: image }, decisionId)
                );
                setIsClose(true);
                setLoading(true);
                // if(option.image){
                // setIsUpload(false)
                // }
              }}
            >
              {imgLoader ? <Spin /> : "UPLOAD"}
            </button>
          )}

          {(!image || (size >= 2 && !option.image)) && (
            <button
              className={classes.upload}
              onClick={() => {
                setIsUpload(false);
              }}
            >
              Close
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export { UploadModal };
